interface GoogleConfig {
  API_KEY: string;
  CLIENT_ID: string;
  SECRET: string;
}

interface FacebookConfig {
  APP_ID: string;
}

interface ApiConfig {
  API_URL: string;
}

interface Config {
  google: GoogleConfig;
  facebook: FacebookConfig;
  api: ApiConfig;
}

const sanitizeBaseUrl = (value: string): string => value.endsWith('/') ? value.slice(0, -1) : value;

const DEFAULT_API_URL = "http://localhost:8080";

const apiBaseUrl = sanitizeBaseUrl(process.env.REACT_APP_API_URL || DEFAULT_API_URL);

const config: Config = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: apiBaseUrl,
  },
};

export default config;
